import { Flex } from 'antd';
import { formatCurrencyShortened } from 'utils/helpers';
import DueStatusBar from './DueStatusBar';
import {
  formatAgronomistDueList,
  overdueStatusProperties,
  OverdueStatusPropertiesKey,
} from '../helper';
import SearchBox from 'components/SearchBox';
import { useTranslation } from 'react-i18next';
import { useMemo, useState } from 'react';
import { CollectionsDueAgronomist } from '../hooks/useDueAgronomistQuery';

type AgronomistDueWidgetProps = {
  data?: CollectionsDueAgronomist[];
};

const AgronomistDueWidget = ({ data }: AgronomistDueWidgetProps) => {
  const [searchAgronomist, setSearchAgronomist] = useState('');
  const { t } = useTranslation();

  const formattedAgronomistDueList = useMemo(
    () =>
      formatAgronomistDueList(data).filter((item) =>
        item.agronomistName
          .toLowerCase()
          .includes(searchAgronomist.toLowerCase()),
      ),
    [data, searchAgronomist],
  );

  return (
    <div className="base-card agronomist-overview-container">
      <Flex justify="space-between" className="flex-col-sm flex-gap-sm">
        <div className="text-large text-strong">
          {formattedAgronomistDueList?.length} {t('users.Agronomists')}
        </div>
        <div>
          <SearchBox
            showLabel={false}
            placeholder={t('common.filters.agronomistPlaceholder')}
            onSearch={setSearchAgronomist}
          />
        </div>
      </Flex>

      <Flex vertical gap={20} className="agronomist-overview-list">
        {formattedAgronomistDueList?.map((item, index) => (
          <div
            key={item.agronomistName + index}
            className="flex-vertical agronomist-overview-section"
          >
            <Flex justify="space-between">
              <span className="text-base">{item.agronomistName}</span>
              <span className="text-base text-strong">
                Rp {formatCurrencyShortened(item.totalDueBalance)}
              </span>
            </Flex>
            <Flex style={{ overflow: 'hidden' }}>
              {item.agronomistDueStatus?.map((due) => (
                <DueStatusBar
                  key={due.dueStatus + '-bar-' + due.remainingBalance}
                  due={due}
                  totalBalance={item.totalDueBalance}
                />
              ))}
            </Flex>
            <Flex className="agronomist-due-container flex-col-sm">
              {item.agronomistDueStatus?.map((due) => (
                <div
                  key={due.dueStatus}
                  className="flex-center agronomist-due-info"
                >
                  <div
                    className={`due-status-dot ${overdueStatusProperties?.[due.dueStatus as OverdueStatusPropertiesKey].color}`}
                  />
                  {
                    overdueStatusProperties?.[
                      due.dueStatus as OverdueStatusPropertiesKey
                    ].title
                  }
                  : {formatCurrencyShortened(due.remainingBalance)}
                </div>
              ))}
            </Flex>
          </div>
        ))}
      </Flex>
    </div>
  );
};

export default AgronomistDueWidget;
